export default __webpack_public_path__ + "static/media/dashimg.a89561b7.png";